import React from "react";

import AnnouncementOptions from "./AnnouncementOptions";
import AnnouncementsOptions from "./AnnouncementsOptions";
import { useAnnouncementsStore } from "../../../../../../stores/use-announcements-store";

const AnnouncementsSettings = () => {
  const selectedAnnouncement = useAnnouncementsStore(
    (state) => state.selectedAnnouncement
  );

  const AnnouncementsSettingsComponent = selectedAnnouncement
    ? AnnouncementOptions
    : AnnouncementsOptions;

  return <AnnouncementsSettingsComponent />;
};

export default AnnouncementsSettings;
